export default __webpack_public_path__ + "static/mars-quote-banner-33511ec706f933a745358d6ce3427ed8.jpg";